import utils from 'utils'
import '../../assets/less1/print.css'
import statisticsDeductionCheckPage from './view/statisticsDeductionCheck.html'

import manualsolutionModal from './../../views/common/manualsolutionModal.html'

export default function statisticsDeductionCheck(
  httpRequest,
  logger,
  $timeout,
  sweetalert,
  $uibModal,
  operationService,
  selectManualSolution
) {
  return {
    restrict: 'E',
    template: statisticsDeductionCheckPage,
    link: function (scope) {
      if (!operationService.hasPermit('deduction_statistics')) {
        return
      }


      utils.loading('处理中')
      const dictionaryTypes = [
        'ivat_orig_inv_type', // 明细表发票种类
        'ivat_orig_inv_auth_type', // 明细表用途
        'ivat_invoice_status', // 明细表发票状态
        'manager_status', // 明细表管理状态
        'ivat_ele_check_stat_inv_type' // 发票类型
      ]
      httpRequest.get_dictByTypeArr(dictionaryTypes).then((res) => {
        let dictData = {}
        for (let [key, value] of Object.entries(res.data.value)) {
          dictData[key] = [
            {
              enumCode: '',
              enumName: '全部',
            },
            ...value,
          ]
        }
        dictData['YES_NO'] = [
          {
            enumName: '否',
            enumCode: '0',
          },
          {
            enumName: '是',
            enumCode: '1',
          },
        ]
        scope.dictData = dictData
      })
      const userInfo = JSON.parse(localStorage.getItem('user_info'))
      const inputDeviceType =
        (localStorage.inputDeviceType &&
          JSON.parse(localStorage.getItem('inputDeviceType'))) ||
        {}
      scope.saleName = userInfo.sale.saleName
      scope.isInDeclareTime = false
      scope.saleCreditCode = userInfo.sale.saleCreditCode
      httpRequest
        .get_qryOrgTaxPeriod(
          JSON.parse(localStorage.user_info).user.currentOrgId
        )
        .then(
          (res) => {
            const response = res.data.value || {}
            scope.currentTaxPeriod = response.periodCode
              ? response.periodCode.substring(0, 4) +
              '-' +
              response.periodCode.substring(4)
              : null
            scope.expireTime = response.expireTime
            scope.periodName = response.periodName
            scope.taxPeriod = scope.currentTaxPeriod
          },
          () => {
            utils.loaded()
          }
        )
        .finally(() => {
          if (!scope.currentTaxPeriod) {
            logger.logError(
              '未获取当前机构税款所属期，请确认电子底账采集任务已经执行'
            )
          }
          $timeout(() => {
            $('#taxPeriod').datetimepicker({
              autoclose: true,
              startView: 'year',
              minView: 'year',
              language: 'zh-CN',
              format: 'yyyy-mm',
              forceParse: 0,
              pickTime: false,
              pickerPosition: 'bottom-right',
              endDate: scope.currentTaxPeriod,
            })
          })
        })
      httpRequest.get_isDeclareTime().then((res) => {
        if (res.data.value) {
          scope.isInDeclareTime = true
        }
      })

      // scope.reportType = '1'
      scope.serverTypeTmp = ''
      scope.showSearchCondition = false

      scope.invoiceDetailSearchParam = {
        pageNum: 1,
        pageSize: 10,
        totalCount: 0,
        param: {
          invoiceType: '',
          invoiceCode: '',
          invoiceNumber: '',
          checkMinTime: '',
          checkMaxTime: '',
          invoiceMinDate: '',
          invoiceMaxDate: '',
          checkFlag: '',
        },
      }
      scope.reset = function () {
        if (scope.invType === 'normal') {
          scope.invoiceDetailSearchParam.param = {
            invoiceType: '',
            invoiceCode: '',
            invoiceNumber: '',
            checkMinTime: '',
            checkMaxTime: '',
            invoiceMinDate: '',
            invoiceMaxDate: '',
            checkFlag: '',
          }
        }
        if (scope.invType === 'customsPayment') {
          scope.invoiceDetailSearchParam.param = {
            billId: '',
            invoiceMinDate: '',
            invoiceMaxDate: '',
            checkMinTime: '',
            checkMaxTime: '',
          }
        }
      }
      // 打印
      scope.print = () => {
        if (
          !scope.statisticTableData ||
          scope.statisticTableData.checkInvoiceStatList.length < 1 && scope.statisticTableData.elePlatformCheckStatDTOS.length < 1
        ) {
          logger.logError('未生成报表数据，不能打印')
        } else {
          $('#statisticsTable').jqprint({
            importCSS: true, // true表示引进原来的页面的css，默认是true。（如果是true，先会找$("link[media=print]")，若没有会去找$("link")中的css文件）
            printContainer: true, // 表示如果原来选择的对象必须被纳入打印（注意：设置为false可能会打破你的CSS规则）。
            operaSupport: true,
          })
        }
      }

      function getResponseStr(param) {
        $.jsonp({
          url: `${param.serverAddress}`,
          data: {
            SID: param.sid,
            SIDParam: param.sidReqParam,
          },
          timeout: 86400000,
          charset: 'GBK',
          callbackParameter: 'callback',
          success(json) {
            if (json.retcode === '1') {
              if (param.funcName === 'queryStatistics') {
                scope.queryStatistics({
                  responseStr: json.ResponseStr,
                  diskType: param.diskType,
                })
              } else {
                changeStatus({
                  responseStr: json.ResponseStr,
                  applyType: param.applyType,
                  platPassword: param.platPassword,
                  diskType: param.diskType,
                })
              }
            } else {
              logger.logError(json.retmsg)
              utils.loaded()
            }
          },
          error() {
            logger.logError('进项服务连接失败')
            utils.loaded()
          },
        })
      }
      // 统计查询
      scope.queryStatistics = ({
        responseStr,
        isShowLoading,
        diskType,
        isRefresh
      } = {}) => {
        utils.loading('处理中')
        // if (isShowLoading) {
        //   utils.loading('处理中')
        // }
        let param = {
          month: scope.taxPeriod.replace(/\-/, ''),
          type: '1',
          isRefresh
        }
        if (responseStr) {
          param.responseStr = responseStr
          param.type = '2'
          isRefresh
        }
        // if (diskType) {
        //   param.diskType = diskType
        // }
        // param.deviceType = inputDeviceType.deviceType
        httpRequest.post_qryIvatConfig().then((res) => {
          param.deviceType = res.data.value.deviceType
          param.diskType = res.data.value.diskType
          httpRequest.get_invoiceStatQuery(param).then((res) => {
            const result = res.data.value || {}
            if (!responseStr && result.diskType == '1') {
              scope.serverTypeTmp = 'client'
              getResponseStr({
                serverAddress: result.serverAddress,
                sid: result.sid,
                sidReqParam: result.sidReqParam,
                funcName: 'queryStatistics',
                diskType: result.diskType,
              })
            } else {
              scope.statisticTableData = result.response
              if (result.queryResultType == '2') return logger.logSuccess('统计查询成功，当前请求在后台排队中，系统将每五分钟查询一次结果，请稍后刷新查看，超过48小时未查询成功请联系运维查看！')
              utils.loaded()
            }
          })
        })
      }

      function changeStatus({
        applyType,
        responseStr,
        platPassword,
        diskType,
      } = {}) {
        utils.loading('处理中')
        let params = {
          applyType,
          type: '1',
        }
        if (responseStr) {
          params.responseStr = responseStr
          params.type = '2'
        }
        if (platPassword) {
          applyType == '3' ? params.deductionPassword = platPassword : params.platPassword = platPassword
        }
        if (diskType) {
          params.diskType = diskType
        }
        params.deviceType = inputDeviceType.deviceType
        httpRequest.get_statSign(params).then(
          (res) => {
            const result = res.data.value || {}
            //u72返回responseStr为空且后端返回responseType为0，单机版使用后端返回参数调u72，再将u72返回结果responseStr写入get_statSign接口
            if (!responseStr && result.diskType == '1') {
              getResponseStr({
                serverAddress: result.serverAddress,
                sid: result.sid,
                sidReqParam: result.sidReqParam,
                funcName: 'changeStatus',
                applyType,
                responseStr,
                platPassword,
                diskType: result.diskType,
              })
              return
            }
            if (params.applyType === '1') {
              logger.logSuccess('已申请报表统计，稍后查询统计报表')
            } else if (params.applyType === '2') {
              logger.logSuccess('撤销统计成功')
            } else if (params.applyType === '3') {
              logger.logSuccess('确认签名成功')
            } else if (params.applyType === '4') {
              logger.logSuccess('撤销签名成功')
            }
            setTimeout(() => {
              scope.queryStatistics()
            }, 2000);
          },
          () => {
            utils.loaded()
          }
        )
      }
      // applyType(1申请统计、2撤销统计、3确认签名、4撤销签名)
      scope.changeStatisticsStatus = async (applyType) => {
        let flag = await selectManualSolution.getResult()
        if (!flag) return
        if (applyType === '1') {
          sweetalert
            .confirm('操作提醒', '是否确定申请生成统计报表')
            .then(() => {
              changeStatus({
                applyType,
              })
            })
        } else if (applyType === '2') {
          changeStatus({
            applyType,
          })
        } else if (applyType === '3') {
          // 去掉确认签名的弹出框 直接发起确认向后台请求
          httpRequest.get_getUserSaleInfo().then(res => {
            const result = res.data.value["ivatCollectServer"] || {}
            const data = result["deductionPassword"]
            changeStatus({
              applyType,
              platPassword: data
            })
          })

        } else if (applyType === '4') {
          sweetalert
            .confirm('操作提醒', '撤销签名后，若申报需重新申请抵扣统计')
            .then(() => {
              changeStatus({
                applyType,
              })
            })
        }
      }

      // 发票明细
      scope.queryInvoiceDetails = ({ isShowLoading } = {}) => {
        if (isShowLoading) {
          utils.loading('查询中')
        }
        let params = {
          ...scope.invoiceDetailSearchParam,
        }
        params.param.periodCode = scope.taxPeriod
          ? scope.taxPeriod.replace(/\-/, '')
          : ''
        if (scope.invType === 'normal') {
          httpRequest.post_pageQueryInvoiceDetail(params).then(
            (res) => {
              const response = res.data.value || {}
              scope.invoiceDetailTableData = response.list
              scope.invoiceDetailSearchParam.totalCount = response.total
              utils.loaded()
            },
            () => {
              utils.loaded()
            }
          )
        }

        if (scope.invType === 'customsPayment') {
          httpRequest.post_pageQueryCustomsBillDetail(params).then(
            (res) => {
              const response = res.data.value || {}
              scope.invoiceDetailTableData = response.list
              scope.invoiceDetailSearchParam.totalCount = response.total
              utils.loaded()
            },
            () => {
              utils.loaded()
            }
          )
        }
      }
      // 获取当前进度
      scope.getProgressStatus = (index) => {
        let status = 'notStarted'
        if (!scope.statisticTableData) {
          return status
        }
        switch (scope.statisticTableData.status) {
          case 0:
            status = 'notStarted'
            if (index === 1) {
              status = 'active'
            }
            break
          case 1:
            status = 'notStarted'
            if (index === 1) {
              status = 'completed'
            } else if (index === 2) {
              status = 'active'
            }
            break
          case 2:
            status = 'completed'
            if (index === 3) {
              status = 'active'
            }
            break
          case 3:
            status = 'completed'
            break
        }
        return status
      }
      // 改变税款所属期  切换所属期时，不自动进行【统计查询】
      scope.$watch('taxPeriod', (newVal, oldVal) => {
        if (newVal && newVal !== oldVal) {
          scope.taxPeriodName = scope.taxPeriod
            ? scope.taxPeriod.replace(/\-/, '年') + '月'
            : ''
          scope.queryStatistics({
            isShowLoading: true,
            isRefresh: 0
          })
          scope.queryInvoiceDetails({
            isShowLoading: true,
          })
        }
      })

      scope.invTypeChange = function (v) {
        scope.invType = v
        scope.profileTypeObj =
          scope.invType == 'normal'
            ? {
              version: 5.31,
              queryFields: [
                {
                  label: '发票种类',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票代码',
                  selected: true,
                  default: true,
                },
                {
                  label: '发票号码',
                  selected: true,
                  default: true,
                },
                {
                  label: '勾选日期',
                  selected: true,
                  default: true,
                },
                {
                  label: '开票日期',
                  selected: true,
                  default: true,
                },
                {
                  label: '用途',
                  selected: true,
                  default: true,
                },
              ],
              tableColumns: [
                {
                  label: '发票代码',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      key: 'invoiceCode',
                    },
                  ],
                },
                {
                  label: '发票号码',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      key: 'invoiceNumber',
                    },
                  ],
                },
                {
                  label: '开票日期',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'timestrsub',
                      key: 'invoiceDate',
                    },
                  ],
                },
                {
                  label: '销方名称',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      key: 'saleName',
                    },
                  ],
                },
                {
                  label: '金额',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'number',
                      key: 'totalAmt',
                      filterParam: 2,
                    },
                  ],
                },
                {
                  label: '税额',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'number',
                      key: 'totalTaxamt',
                      filterParam: 2,
                    },
                  ],
                },
                {
                  label: '有效税额',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'number',
                      key: 'effectiveTaxamt',
                      filterParam: 2,
                    },
                  ],
                },
                {
                  label: '勾选日期',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'timestrsub',
                      key: 'checkTime',
                    },
                  ],
                },
                {
                  label: '发票种类',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'dictFilter',
                      key: 'invoiceType',
                      filterParam: 'ivat_orig_inv_type',
                    },
                  ],
                },
                {
                  label: '用途',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'dictFilter',
                      key: 'checkFlag',
                      filterParam: 'ivat_orig_inv_auth_type',
                    },
                  ],
                },
                {
                  label: '发票状态',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'dictFilter',
                      key: 'invoiceStatus',
                      filterParam: 'ivat_invoice_status',
                    },
                  ],
                },
                {
                  label: '管理状态',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'dictFilter',
                      key: 'managerStatus',
                      filterParam: 'manager_status',
                    },
                  ],
                },
              ],
            }
            : {
              version: 1.02,
              queryFields: [
                {
                  label: '缴款书号码',
                  selected: true,
                  default: true,
                },
                {
                  label: '填发日期',
                  selected: true,
                  default: true,
                },
                {
                  label: '勾选日期',
                  selected: true,
                  default: true,
                },
              ],
              tableColumns: [
                {
                  label: '缴款书号码',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      key: 'billId',
                    },
                  ],
                },
                {
                  label: '填发日期',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'timestrsub',
                      key: 'billDate',
                    },
                  ],
                },
                {
                  label: '税款金额',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'number',
                      key: 'totalTaxamt',
                      filterParam: 2,
                    },
                  ],
                },
                {
                  label: '有效税款金额',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'number',
                      key: 'effectiveTaxamt',
                      filterParam: 2,
                    },
                  ],
                },
                {
                  label: '勾选时间',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'timestrsub',
                      key: 'checkTime',
                    },
                  ],
                },
                {
                  label: '管理状态',
                  selected: true,
                  default: true,
                  labelContent: [
                    {
                      filter: 'dictFilter',
                      key: 'managerStatus',
                      filterParam: 'manager_status',
                    },
                  ],
                },
              ],
            }

        scope.invoiceDetailSearchParam =
          scope.invType == 'normal'
            ? {
              pageNum: 1,
              pageSize: 10,
              totalCount: 0,
              param: {
                invoiceType: '',
                invoiceCode: '',
                invoiceNumber: '',
                //   checkMinTime: '',
                //   checkMaxTime: '',
                //   invoiceMinDate: '',
                //   invoiceMaxDate: '',
                checkFlag: '',
              },
            }
            : {
              pageNum: 1,
              pageSize: 10,
              totalCount: 0,
              param: {
                billId: '',
                invoiceMinDate: '',
                invoiceMaxDate: '',
                checkMinTime: '',
                checkMaxTime: '',
              },
            }

        scope.queryInvoiceDetails({
          isShowLoading: true,
        })
      }

      scope.invTypeChange('normal')

      scope.backspace = function () {
        $uibModal
          .open({
            templateUrl: 'backspace.html',
            openedClass: 'mod-modal mod-modal-md',
            controller: [
              '$scope',
              '$uibModalInstance',
              'sweetalert',
              'items',
              ($scope, $uibModalInstance, sweetalert, items) => {
                $scope.title = '确认回退税款所属期'
                $scope.periodName = items.periodName
                $scope.beforeTaxPeriod = items.beforeTaxPeriod
                const sale = JSON.parse(localStorage.user_info).sale
                $scope.saleName = sale.saleName
                $scope.saleCreditCode = sale.saleCreditCode
                $scope.ok = () => {
                  utils.loading('税款所属期回退中')
                  interflowDZDZ('post_backTaxPeriod')
                    .then((res) => {
                      if (res.retcode == '1') {
                        sweetalert
                          .confirm('回退成功', '您的回退税款所属期已成功回退!')
                          .then(() => {
                            $uibModalInstance.close()
                          })
                      } else {
                        sweetalert.confirm('回退失败', res.retmsg).then(() => {
                          $uibModalInstance.close()
                        })
                      }
                    })
                    .finally(() => {
                      utils.loaded()
                    })
                }
                $scope.cancel = () => {
                  $uibModalInstance.dismiss()
                }
              },
            ],
            animation: true,
            resolve: {
              items() {
                return {
                  periodName: scope.modPeriod,
                  beforeTaxPeriod: scope.beforeTaxPeriod,
                }
              },
            },
          })
          .result.then(() => {
            interflowDZDZ('post_dkBaseInfoQuery').then((res) => {
              scope.showBackspace = res.canBackPeriod
              scope.taxPeriod = res.currentTaxPeriod
                ? res.currentTaxPeriod.substring(0, 4) +
                '-' +
                res.currentTaxPeriod.substring(4)
                : ''
              scope.currentTaxPeriod = scope.taxPeriod
              scope.periodName = scope.taxPeriod
                ? scope.taxPeriod.replace(/\-/, '年') + '月'
                : ''
              httpRequest.get_isDeclareTime().then((res) => {
                if (res.data.value) {
                  scope.isInDeclareTime = true
                }
              })
            })
          })
      }
      //获取当前税号的进项是否是电子税局，true 电子税
      httpRequest.get_getIsElecTaxBureau().then(res => {
        scope.isElecTaxBureau = res.data.value

        if (!scope.isElecTaxBureau) {
          //增加校验-  电子平台不调用此接口
          interflowDZDZ('post_dkBaseInfoQuery').then(res => {
            scope.showBackspace = res.canBackPeriod
            scope.beforeTaxPeriod = res.beforeTaxPeriod ? (res.beforeTaxPeriod.substring(0, 4) + '年' + res.beforeTaxPeriod.substring(4) + '月') : ''
            scope.modPeriod = res.currentTaxPeriod ? (res.currentTaxPeriod.substring(0, 4) + '年' + res.currentTaxPeriod.substring(4) + '月') : ''
          })
        }
      })
      //   interflowDZDZ('post_dkBaseInfoQuery').then((res) => {
      //     scope.showBackspace = res.canBackPeriod
      //     scope.beforeTaxPeriod = res.beforeTaxPeriod
      //       ? res.beforeTaxPeriod.substring(0, 4) +
      //         '年' +
      //         res.beforeTaxPeriod.substring(4) +
      //         '月'
      //       : ''
      //     scope.modPeriod = res.currentTaxPeriod
      //       ? res.currentTaxPeriod.substring(0, 4) +
      //         '年' +
      //         res.currentTaxPeriod.substring(4) +
      //         '月'
      //       : ''
      //   })

      function interflowDZDZ(API) {
        return new Promise((resolve, reject) => {
          //1.通过查询单机版还是服务器版
          httpRequest[API]({}).then((res) => {
            const result = res.data.value
            if (result.diskType == 1) {
              //单机
              $.jsonp({
                url: `${result.serverAddress}`,
                data: {
                  SID: result.sid,
                  SIDParam: result.sidReqParam,
                },
                timeout: 86400000,
                charset: 'GBK',
                callbackParameter: 'callback',
                success(json) {
                  if (json.retcode == '1') {
                    httpRequest[API]({
                      diskType: result.diskType,
                      responseStr: json.ResponseStr,
                    }).then((res1) => {
                      resolve(res1.data.value.response)
                    })
                  } else {
                    logger.logError(json.retmsg)
                    reject()
                  }
                },
                error() {
                  logger.logError('进项服务连接超时')
                  reject()
                },
              })
            } else {
              //服务器
              resolve(result.response)
            }
          })
        })
      }
      // 导出
      scope.exportInvoice = function () {
        let params = {
          ...scope.invoiceDetailSearchParam.param,
        }
        params.periodCode = scope.taxPeriod ? scope.taxPeriod.replace(/\-/, '') : ''
        // params.accessToken = localStorage.id_token
        const _url = `${host.etcloudIvatApp}auth/ivatDeductionCheckStatSign/exportStatisticsDetailExcel?accessToken=${localStorage.getItem('id_token')}`
        utils.post_downLoad(params, _url)
      }

      function isToday(dateString) {
        // 解析传入的日期字符串
        const inputDate = new Date(dateString);

        // 获取当前日期
        const today = new Date();

        // 比较年月日是否相同
        return inputDate.getFullYear() === today.getFullYear() &&
          inputDate.getMonth() === today.getMonth() &&
          inputDate.getDate() === today.getDate();
      }

      function init() {
        if (!operationService.hasPermit('deduction_statistics')) {
          return
        }


        utils.loading('处理中')
        const dictionaryTypes = [
          'ivat_orig_inv_type', // 明细表发票种类
          'ivat_orig_inv_auth_type', // 明细表用途
          'ivat_invoice_status', // 明细表发票状态
          'manager_status', // 明细表管理状态
          'ivat_ele_check_stat_inv_type' // 发票类型
        ]
        httpRequest.get_dictByTypeArr(dictionaryTypes).then((res) => {
          let dictData = {}
          for (let [key, value] of Object.entries(res.data.value)) {
            dictData[key] = [
              {
                enumCode: '',
                enumName: '全部',
              },
              ...value,
            ]
          }
          dictData['YES_NO'] = [
            {
              enumName: '否',
              enumCode: '0',
            },
            {
              enumName: '是',
              enumCode: '1',
            },
          ]
          scope.dictData = dictData
        })

        httpRequest
          .get_qryOrgTaxPeriod(
            JSON.parse(localStorage.user_info).user.currentOrgId
          )
          .then(
            (res) => {
              const response = res.data.value || {}
              scope.currentTaxPeriod = response.periodCode
                ? response.periodCode.substring(0, 4) +
                '-' +
                response.periodCode.substring(4)
                : null
              scope.expireTime = response.expireTime
              scope.periodName = response.periodName
              scope.taxPeriod = scope.currentTaxPeriod
            },
            () => {
              utils.loaded()
            }
          )
          .finally(() => {
            if (!scope.currentTaxPeriod) {
              logger.logError(
                '未获取当前机构税款所属期，请确认电子底账采集任务已经执行'
              )
            }
            $timeout(() => {
              $('#taxPeriod').datetimepicker({
                autoclose: true,
                startView: 'year',
                minView: 'year',
                language: 'zh-CN',
                format: 'yyyy-mm',
                forceParse: 0,
                pickTime: false,
                pickerPosition: 'bottom-right',
                endDate: scope.currentTaxPeriod,
              })
            })
          })
        httpRequest.get_isDeclareTime().then((res) => {
          if (res.data.value) {
            scope.isInDeclareTime = true
          }
        })

        // scope.reportType = '1'

        scope.invTypeChange('normal')


        //获取当前税号的进项是否是电子税局，true 电子税
        httpRequest.get_getIsElecTaxBureau().then(res => {
          scope.isElecTaxBureau = res.data.value

          if (!scope.isElecTaxBureau) {
            //增加校验-  电子平台不调用此接口
            interflowDZDZ('post_dkBaseInfoQuery').then(res => {
              scope.showBackspace = res.canBackPeriod
              scope.beforeTaxPeriod = res.beforeTaxPeriod ? (res.beforeTaxPeriod.substring(0, 4) + '年' + res.beforeTaxPeriod.substring(4) + '月') : ''
              scope.modPeriod = res.currentTaxPeriod ? (res.currentTaxPeriod.substring(0, 4) + '年' + res.currentTaxPeriod.substring(4) + '月') : ''
            })
          }
        })
      }
      let setInfo
      httpRequest.get_getUserCustomizedInfo(1000).then(res => {
        setInfo = res.data.value || {}
        if (isToday(setInfo && setInfo.updateTime)) {
          init()
        } else {
          $uibModal
            .open({
              template: manualsolutionModal,
              openedClass: 'mod-modal mod-modal-hg',
              controller: [
                '$scope',
                '$uibModalInstance',
                '$timeout',
                'diskConfig',
                'httpRequest',
                function ($scope, $uibModalInstance, $timeout, diskConfig, httpRequest) {
                  if (diskConfig) {
                    $scope.manualTag = diskConfig
                  } else {
                    $scope.manualTag = '0'
                  }

                  $scope.ok = function () {
                    utils.loading('请求已发送')
                    httpRequest.post_saveUserCustomized({
                      profileInfo: JSON.stringify(
                        Number($scope.manualTag)),
                      profileType: '1000',
                    }).then(res => {
                      utils.loaded()
                      logger.logSuccess('保存成功')
                      $uibModalInstance.close()

                    })

                  }
                  $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel')
                  }
                },
              ],
              animation: true,
              resolve: {
                diskConfig() {
                  return setInfo.profileInfo || '0'
                },
              },
            })
            .result.then((obj) => {
              init()
            }, () => {
              console.log('什么都不执行')
            })
        }
      })




      init()
    },

  }
}

statisticsDeductionCheck.$inject = [
  'httpRequest',
  'logger',
  '$timeout',
  'sweetalert',
  '$uibModal',
  'operationService',
  'selectManualSolution',
]



// WEBPACK FOOTER //
// ./src/components/statisticsDeductionCheck/statisticsDeductionCheck.js